<template>
  <div class="templates-panel !overflow-visible" 
       :class="{ 'show': show, 'pointer-events-none': !show }">
    <div class="flex items-center justify-between !bg-secondary tooltip tooltip-top px-4 rounded-t-lg" data-tip="Use pre-written content templates to jumpstart your creations.  Manage templates in the settings page.">
      <div class="!text-white flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 6.878V6a2.25 2.25 0 0 1 2.25-2.25h7.5A2.25 2.25 0 0 1 18 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 0 0 4.5 9v.878m13.5-3A2.25 2.25 0 0 1 19.5 9v.878m0 0a2.246 2.246 0 0 0-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0 1 21 12v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6c0-.98.626-1.813 1.5-2.122" />
            </svg>
        Templates
      </div>
      <a href="#" class="close-templates" @click.prevent="$emit('close')">×</a>
    </div>
    <div class="templates-list !overflow-scroll">
      <div class="template-item" v-for="template in templates" :key="template.$id" @click="selectTemplate(template)">
        <h4>{{ template.title }}</h4>
        <p>{{ template.prompt.substring(0, 100) }}...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplatesPanel',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    templates: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    selectTemplate(template) {
      this.$emit('select-template', template);
    }
  }
}
</script>

<style scoped>
.templates-panel {
  position: absolute;
  top: 0;
  left: 200px; /* Start position - hidden to the left */
  width: 300px;
  height: 100%;
  background: #fff;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  border-radius: 8px;
  overflow: hidden;
  z-index: -1;
  opacity: 0;
  transform: translateX(-100%);
}

.templates-panel.show {
  transform: translateX(-505px);
  opacity: 1;
}

.templates-header {
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(45deg, #0a0909, #3d0418) !important;
  position: sticky;
  top: 0;
  z-index: 1;
}

.templates-header h3 {
  margin: 0;
  font-size: 16px;
  color: #fff;
}

.close-templates {
  font-size: 20px;
  color: #fff;
  text-decoration: none;
  padding: 5px;
}

.templates-list {
  padding: 10px;
  height: calc(100% - 80px);
  overflow-y: auto;
  direction: rtl;
}

.template-item {
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  direction: ltr;
}

.template-item:hover {
  background-color: #f8f8f8;
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.template-item h4 {
  margin: 0 0 5px 0;
  font-size: 14px;
  color: #333;
}

.template-item p {
  margin: 0;
  font-size: 12px;
  color: #666;
}

/* Custom scrollbar styles */
.templates-list::-webkit-scrollbar {
  width: 8px;
  background: #f1f1f1;
}

.templates-list::-webkit-scrollbar-thumb {
  background: pink;
  border-radius: 10px;
}

.templates-list::-webkit-scrollbar-thumb:hover {
  background: pink;
}

.pointer-events-none {
  pointer-events: none;
}
</style> 